import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { PostagemItem } from "../typings";

function usePostagens(data?: PaginateQuery) {
  const {
    page = 1,
    limit = 32,
    search = undefined,
  } = data ?? {
    page: 1,
    limit: 32,
    search: undefined,
  };
  return useQuery([`/v1/votacao-${page}-${limit}-${search}`], async () => {
    const res = await axios.get<PaginateResult<PostagemItem>>(`/v1/mural`, {
      params: {
        page,
        limit,
        search,
      },
    });

    return res.data;
  });
}

export default usePostagens;
